export default class SelectedSpecs {
    values = {};

    constructor(specCombinationKey) {
        if (!specCombinationKey) {
            return;
        }
        specCombinationKey.split('-').forEach(spec => {
            const [key, value] = spec.split(':');
            this.values[key] = value;
        });
    }

    delete(spec) {
        delete this.values[spec];
    }
    get(spec) {
        return this.values[spec];
    }

    set(spec, value) {
        this.values[spec] = value;
    }

    clone() {
        return new SelectedSpecs(this.toString());
    }

    toString() {
        return transformSelectedSpecsToString(this.values);
    }
}

export const transformSelectedSpecsToString = specs => {
    return Object.entries(specs)
        .sort((first, second) => (first[0] > second[0] ? 1 : first[0] < second[0] ? -1 : 0))
        .map(([key, value]) => `${key}:${value}`)
        .join('-');
};
